import { render } from "./TablaProveedor.vue?vue&type=template&id=41da7ea3&scoped=true"
import script from "./TablaProveedor.vue?vue&type=script&lang=js"
export * from "./TablaProveedor.vue?vue&type=script&lang=js"

import "./TablaProveedor.vue?vue&type=style&index=0&id=41da7ea3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41da7ea3"]])

export default __exports__